<template>
  <div onselectstart="return false;" style="width:100%;height:100%;font-size:4vw"  v-loading="this.$store.state.isLoading">
  <!-- <div onselectstart="return false;" style="width:100%;height:100%;font-size:0.8vw"> -->
    <!-- 作业考卷 展开 -->
    <el-drawer
      title="我是标题"
      :visible.sync="drawer_homework_exam"
      direction="rtl"
      size='100vw'
      :with-header="false">
      <div class='unfold_wrapper'>
        <div class='unfold_content' style="margin-bottom:2vw">
          <div v-for="(item,index) in list_unfold" :key="index">
             <div class='unfold_content_title' v-if="item.topicList.length">
               {{item.name}}
             </div>
             <div v-for="(data,i) in item.topicList" :key="i" class="unfold_content_content" @click="addto_canvas(data)">
               <div v-html="data.content" style="height:28vw;overflow: hidden;">
                
               </div>
               <!-- <div style="display:flex;justify-content: space-between;height:6.3vw;">
                 <div></div> -->
                 <!-- <el-button type="primary" size="mini" style="background:#13BFA3;border-color:#13BFA3" @click="addto_canvas(data)">载入</el-button> -->
                 <!-- <div class='button_wss' style="background:#13BFA3;border-color:#13BFA3" @click="addto_canvas(data)">载入</div> -->
               <!-- </div> -->
             </div>
          </div>
        </div>
        <div style="height:10vw;background:#13BFA3;width:60%;margin:0 20% 2vw 20%;cursor: pointer;line-height:10vw;text-align:center;color:#ffffff;font-size:4vw" @click="addto_canvas(list_unfold_add_all)">
          全部载入
        </div>
        <div class='unfold_foot' >
          <div>{{unfold_name}}</div>
          <!-- <div style="cursor: pointer;" @click="drawer_homework_exam=false"><el-button style="border-color:#13BFA3;background-color:#C9ECE6;color:#13BFA3" type="primary" icon="el-icon-arrow-left" size="mini">返回</el-button></div> -->
          <div style="cursor: pointer;" @click="drawer_homework_exam=false"><div style="height:3.3vw;line-height:3.3vw;border-color:#13BFA3;background-color:#C9ECE6;color:#13BFA3"  icon="el-icon-arrow-left" class='button_wss'>返回</div></div>        </div>
      </div>
    </el-drawer>
    <!-- 资料 展开 -->
    <el-drawer
      title="我是标题"
      :visible.sync="drawer_data"
      direction="rtl"
      size='100vw'
      :with-header="false">
      <div class='unfold_wrapper'>
        <!-- <div class='unfold_content'>
          <div v-for="(item,index) in list_unfold_data" :key="index" class='dataItem' style="background:#f2f2f2"  @click="addto_canvas(item)">
            <div class='iconfont iconPPT' style="color:#f77737" v-if="(li_active==1||li_active==5||li_active==6||li_active==7||li_active==8)&&(item.type=='ppt'||item.type=='pptx')"></div>
            <div class='iconfont iconword' style="color:#4a91f4" v-else-if="(li_active==1||li_active==5||li_active==6||li_active==7||li_active==8)&&(item.type=='doc'||item.type=='docx'||item.type=='DOC'||item.type=='DOCX')"></div>
            <div class='iconfont icontupian1' style="color:#27d0d8" v-else-if="(li_active==1||li_active==5||li_active==6||li_active==7||li_active==8)&&(item.type=='jpg'||item.type=='png'||item.type=='jpeg'||item.type=='gif')"></div>
            <div class='iconfont iconshipin' style="color:#738be0" v-else-if="(li_active==1||li_active==5||li_active==6||li_active==7||li_active==8)&&(item.type=='mp4'||item.type=='MP4'||item.type=='wmv'||item.type=='WMV'||item.type=='flv'||item.type=='FLV')"></div>
            <div class='iconfont iconpdf' style="color:#fa4e4e" v-else-if="(li_active==1||li_active==5||li_active==6||li_active==7||li_active==8)&&(item.type=='pdf'||item.type=='PDF')"></div>
            <div class='iconfont iconyinpin' style="color:#4fbded" v-else-if="(li_active==1||li_active==5||li_active==6||li_active==7||li_active==8)&&(item.type=='mp3'||item.type=='MP3')"></div>
            <div class='iconfont iconbangzhu' style="color:#CCCCCC" v-else></div>
            <div>{{item.name||item.title}}</div>
            <div :style="{'width':'15vw'}">
              
            </div>
          </div>
        </div> -->
         <ul class="infinite-list content_2" style="overflow:auto;display:flex;flex-wrap:wrap" >
          <li v-for='(item ,index) in list_unfold_data' :key="index" class='dataItem_2'
           @click="addto_canvas(item)">
        
             <div class="dataItem_contnet" style="width:100%;height:100%">
        
              <img style="width:100%;height:100%;margin:0"  v-if="(item.type=='pptx'||item.type=='PPTX'||item.type=='ppt'||item.type=='PPT')&&item.thumb" :src="item.thumb" alt="">
              <img  v-else-if="(item.type=='pptx'||item.type=='PPTX'||item.type=='ppt'||item.type=='PPT')&&!item.thumb" src="../../assets/images/resource/ppt.png" alt="">
              <img v-if="(item.type=='doc'||item.type=='DOC'||item.type=='docx'||item.type=='DOCX')" src="../../assets/images/resource/word.png" alt="">
              <img v-if="(item.type=='pdf'||item.type=='PDF')" src="../../assets/images/resource/pdf.png" alt="">
              <img v-if="(item.type=='xsl'||item.type=='xslx')" src="../../assets/images/resource/excel.png" alt="">
   
              
              <img style="width:100%;height:100%;margin:0" v-if="item.type=='png'||item.type=='jpg'||item.type=='JPG'||item.type=='JPEG'||item.type=='PNG'||item.type=='jpeg'||item.type=='gif'||item.type=='GIF'" :src="userInfo.school.server_url+item.url"  alt="">
              <img v-if="item.type=='mp3'" src="../../assets/images/resource/音频.png"  alt="">
              <img  v-if="item.type == 'mp4' || item.type == 'MP4'|| item.type == 'wmv'|| item.type == 'WMV'|| item.type == 'mpg'|| item.type == 'MPG'|| item.type == 'avi'|| item.type == 'AVI'|| item.type == 'swf'|| item.type == 'SWF'|| item.type == 'flv'|| item.type == 'FLV'" src="../../assets/images/resource/视频.png"  alt="">

            </div>
           
            <div class="dataItem_name" >
              <!-- <div v-if="li_active==2"><img src="../../assets/images/resource/作业.png" alt=""></div> -->
              <!-- <div v-if="li_active==1"><img src="../../assets/images/resource/资料包.png" alt=""></div> -->
              <!-- <div v-if="li_active==5&&(JSON.parse(item.file)[0].type=='doc'||JSON.parse(item.file)[0].type=='docx'||JSON.parse(item.file)[0].type=='DOC'||JSON.parse(item.file)[0].type=='DOCX')"><img src="../../assets/images/resource/word.png" alt=""></div> -->
              <!-- <div v-if="li_active==5&&(JSON.parse(item.file)[0].type=='pptx'||JSON.parse(item.file)[0].type=='PPTX'||JSON.parse(item.file)[0].type=='ppt'||JSON.parse(item.file)[0].type=='PPT')"><img src="../../assets/images/resource/ppt.png" alt=""></div> -->
              <!-- <div v-if="li_active==5&&(JSON.parse(item.file)[0].type=='pdf'||JSON.parse(item.file)[0].type=='PDf')"><img src="../../assets/images/resource/pdf.png" alt=""></div> -->
              <!-- <div v-if="li_active==6"><img src="../../assets/images/resource/图片.png" alt=""></div> -->
              <!-- <div v-if="li_active==7"><img src="../../assets/images/resource/音频.png" alt=""></div> -->
              <!-- <div v-if="li_active==8"><img src="../../assets/images/resource/视频.png" alt=""></div> -->
              <div style="overflow:hidden">{{item.name||item.title}}</div>
              </div>
          </li>
        </ul>
        <div class='unfold_foot'>
          <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{unfold_name}}</div>
          <!-- <div style="cursor: pointer;" @click="drawer_data=false"><el-button style="border-color:#13BFA3;background-color:#C9ECE6;color:#13BFA3" type="primary" icon="el-icon-arrow-left" size="mini">返回</el-button></div> -->
          <div style="cursor: pointer;" @click="drawer_data=false"><div style="height:3.3vw;line-height:3.3vw;border-color:#13BFA3;background-color:#C9ECE6;color:#13BFA3"  icon="el-icon-arrow-left" class='button_wss'>返回</div></div>
        </div>
      </div>
    </el-drawer>
    <div class='head_box' style="display:flex;">
      <div class='left_box'>
        <div ></div>  
        <!-- 新版本 -->
        <ul class="infinite-list content_2" v-infinite-scroll="load" style="overflow:auto;display:flex;flex-wrap:wrap" v-if="li_active!=4">
          <li v-for='(item ,index) in list_usual' :key="index" class='dataItem_2'
           @click="(li_active==1)?preview_data(item):(li_active==2||li_active==3?preview_homework_exam(item):addto_canvas(item))">
             <div class="dataItem_contnet" style="width:100%;height:100%">
               
              <img style="width:100%;height:100%;margin:0"  v-if="li_active==5&&(JSON.parse(item.file)[0].type=='pptx'||JSON.parse(item.file)[0].type=='PPTX'||JSON.parse(item.file)[0].type=='ppt'||JSON.parse(item.file)[0].type=='PPT')&&JSON.parse(item.file)[0].thumb" :src="JSON.parse(item.file)[0].thumb" alt="">
              <img  v-else-if="li_active==5&&(JSON.parse(item.file)[0].type=='pptx'||JSON.parse(item.file)[0].type=='PPTX'||JSON.parse(item.file)[0].type=='ppt'||JSON.parse(item.file)[0].type=='PPT')&&!JSON.parse(item.file)[0].thumb" src="../../assets/images/resource/ppt.png" alt="">
              <!-- <img style="width:100%;height:100%;margin:0"  v-if="li_active==5&&(JSON.parse(item.file)[0].type=='doc'||JSON.parse(item.file)[0].type=='DOC'||JSON.parse(item.file)[0].type=='docx'||JSON.parse(item.file)[0].type=='DOCX')&&JSON.parse(item.file)[0].thumb" :src="JSON.parse(item.file)[0].thumb" alt=""> -->
              <img v-if="li_active==5&&(JSON.parse(item.file)[0].type=='doc'||JSON.parse(item.file)[0].type=='DOC'||JSON.parse(item.file)[0].type=='docx'||JSON.parse(item.file)[0].type=='DOCX')" src="../../assets/images/resource/word.png" alt="">
              <img v-if="li_active==5&&(JSON.parse(item.file)[0].type=='pdf'||JSON.parse(item.file)[0].type=='PDF')" src="../../assets/images/resource/pdf.png" alt="">
              <img v-if="li_active==2" src="../../assets/images/resource/作业.png"  alt="">
              <img v-if="li_active==1" src="../../assets/images/resource/资料包.png"  alt="">
              <img style="width:100%;height:100%;margin:0" v-if="li_active==6" :src="userInfo.school.server_url+JSON.parse(item.file)[0].url"  alt="">
              <img v-if="li_active==7" src="../../assets/images/resource/音频.png"  alt="">
              <img v-if="li_active==8" src="../../assets/images/resource/视频.png"  alt="">

            </div>
           
            <div class="dataItem_name" >
              <!-- <div v-if="li_active==2"><img src="../../assets/images/resource/作业.png" alt=""></div> -->
              <!-- <div v-if="li_active==1"><img src="../../assets/images/resource/资料包.png" alt=""></div> -->
              <!-- <div v-if="li_active==5&&(JSON.parse(item.file)[0].type=='doc'||JSON.parse(item.file)[0].type=='docx'||JSON.parse(item.file)[0].type=='DOC'||JSON.parse(item.file)[0].type=='DOCX')"><img src="../../assets/images/resource/word.png" alt=""></div> -->
              <div v-if="li_active==5&&(JSON.parse(item.file)[0].type=='pptx'||JSON.parse(item.file)[0].type=='PPTX'||JSON.parse(item.file)[0].type=='ppt'||JSON.parse(item.file)[0].type=='PPT')"><img src="../../assets/images/resource/ppt.png" alt=""></div>
              <!-- <div v-if="li_active==5&&(JSON.parse(item.file)[0].type=='pdf'||JSON.parse(item.file)[0].type=='PDf')"><img src="../../assets/images/resource/pdf.png" alt=""></div> -->
              <!-- <div v-if="li_active==6"><img src="../../assets/images/resource/图片.png" alt=""></div> -->
              <!-- <div v-if="li_active==7"><img src="../../assets/images/resource/音频.png" alt=""></div> -->
              <!-- <div v-if="li_active==8"><img src="../../assets/images/resource/视频.png" alt=""></div> -->
              <div style="overflow:hidden">{{item.name||item.title}}</div>
              </div>
          </li>
        </ul>
        
        <!-- <ul class='content_2 infinite' ref='listBox' v-if="li_active!=4"  v-infinite-scroll="load" style="overflow:auto">
          <li v-for='(item ,index) in list_usual' :key="index" class='dataItem_2' 
           @click="(li_active==1)?preview_data(item):(li_active==2||li_active==3?preview_homework_exam(item):addto_canvas(item))">
            <div class="dataItem_contnet">
              <img src="../../assets/images/resource/作业.png" alt="">
            </div>
            <div class="dataItem_name">
              <div v-if="li_active==2"><img src="../../assets/images/resource/作业.png" alt=""></div>
              <div v-if="li_active==1"><img src="../../assets/images/resource/资料包.png" alt=""></div>
              <div v-if="li_active==5&&(JSON.parse(item.file)[0].type=='doc'||JSON.parse(item.file)[0].type=='docx'||JSON.parse(item.file)[0].type=='DOC'||JSON.parse(item.file)[0].type=='DOCX')"><img src="../../assets/images/resource/word.png" alt=""></div>
              <div v-if="li_active==5&&(JSON.parse(item.file)[0].type=='pptx'||JSON.parse(item.file)[0].type=='PPTX'||JSON.parse(item.file)[0].type=='ppt'||JSON.parse(item.file)[0].type=='PPT')"><img src="../../assets/images/resource/word.png" alt=""></div>
              <div v-if="li_active==5&&(JSON.parse(item.file)[0].type=='pdf'||JSON.parse(item.file)[0].type=='PDf')"><img src="../../assets/images/resource/word.png" alt=""></div>
              <div v-if="li_active==6"><img src="../../assets/images/resource/图片.png" alt=""></div>
              <div v-if="li_active==7"><img src="../../assets/images/resource/音频.png" alt=""></div>
              <div v-if="li_active==8"><img src="../../assets/images/resource/视频.png" alt=""></div>
              <div>{{item.type}}_{{item.name||item.title}}</div>
              </div>
          </li>
         
        </ul> -->
        
        <!--  -->
        
        <div class='content_1' ref='listBox' v-else-if='li_active==4'>
           <!-- <div v-for='(item ,index) in list_usual' :key="index" class='dataItem_topic'>
             {{item.content}}
           </div> -->
           
          <div v-for="(item,index) in list_usual" :key="index" style="margin:1.43vw 1.5vw 0 1.5vw;background:white" @click="addto_canvas(item)">
             <div class='unfold_content_title' >
               {{returnTopic_type(item.type_id)}}
             </div>
             <div  class="unfold_content_content" >
               <div v-html="item.content" style="height:28vw;overflow: hidden;">
               </div>
               <!-- <div style="display:flex;justify-content: space-between;height:6.33vw;">
                 <div></div> -->
                 <!-- <el-button type="primary" size="mini" style="background:#13BFA3;border-color:#13BFA3" @click="addto_canvas(item)">载入</el-button> -->
                 <!-- <div class='button_wss' style="background:#13BFA3;border-color:#13BFA3" @click="addto_canvas(item)">载入</div> -->
               <!-- </div> -->
             </div>
          </div>
        </div>
        <div></div>
     <!-- 习题 类型难度 -->
        <div class="choose_status" v-if="li_active==4">
            <div @click="choose_topic_level('',-1)" :class="topic_level_avtive==-1?'status_active':''">全部</div>
            <div v-for="(item,index) in topic_level" :key="index" @click="choose_topic_level(item.id,index)" :class="topic_level_avtive==index?'status_active':''">
              {{item.name}}
            </div>
        </div>
        <div class="choose_status" v-if="li_active==4">
          <div @click="choose_topic_type('',-1)" :class="type_json_active==-1?'status_active':''">全部</div>
            <div v-for="(item,index) in type_json" :key="index" @click="choose_topic_type(item.id,index)" :class="type_json_active==index?'status_active':''">
              {{item.n}}
            </div>
        </div>
      </div>
      <div class="right_box">
        <ul style="width:15vw">
          <!-- <li :class="li_active==0?'li_active':''" @click="choose_type(0)"><div class='item_icon iconfont icondaoxuean'></div><div style="line-height:4vw">导学案</div> </li> -->
 
          <li :class="li_active==2?'li_active':''" @click="choose_type(2)"><div class='item_icon iconfont iconzuoye01'></div><div  style="line-height:4vw">作业</div></li>
                   <li :class="li_active==1?'li_active':''" @click="choose_type(1)"><div class='item_icon iconfont iconziliao'></div><div  style="line-height:4vw">资料包</div></li>
                   <li :class="li_active==5?'li_active':''" @click="choose_type(5)"><div class='item_icon iconfont iconwenjianjia'></div><div  style="line-height:4vw">课件</div></li>
                   <li :class="li_active==6?'li_active':''" @click="choose_type(6)"><div class='item_icon iconfont icontupian1'></div><div  style="line-height:4vw">图片</div></li>
                   <li :class="li_active==7?'li_active':''" @click="choose_type(7)"><div class='item_icon iconfont iconyinpin'></div><div  style="line-height:4vw">音频</div></li>
                   <li :class="li_active==8?'li_active':''" @click="choose_type(8)"><div class='item_icon iconfont iconshipin'></div><div  style="line-height:4vw">视频</div></li>
          <!-- <li :class="li_active==3?'li_active':''" @click="choose_type(3)"><div class='item_icon iconfont iconkaoshi1'></div>考卷</li> -->
          <li :class="li_active==4?'li_active':''" @click="choose_type(4)"><div class='item_icon iconfont icontimu'></div><div  style="line-height:4vw">题库</div></li>
        </ul>
      </div>
    </div>
    <div class='foot_box'>
      <div class="data_form">
        <div :class="[data_form_active==0?'data_form_active':'']" @click="data_form(0)"><i class="iconfont iconwode"></i> 我的</div>
        <div :class="[data_form_active==1?'data_form_active':'']" @click="data_form(1)"><i class='iconfont icongongxiang'></i> 共享</div>
        <div :class="[data_form_active==2?'data_form_active':'']" @click="data_form(2)"><i class='iconfont iconxuexiao'></i> 学校</div>
        <div :class="[data_form_active==3?'data_form_active':'']" @click="data_form(3)"><i class='iconfont iconyunduan'></i> 云端</div>
      </div>
      <!-- <div class='foot_back' @click="close_dataBank">
  
        
        <div style="margin: 2vw 0;height:3.3vw;line-height:3.3vw;border-color:#13BFA3;background-color:#C9ECE6;color:#13BFA3;padding-left:1vw;padding-right:1vw;margin-left:1.35vw"  icon="el-icon-arrow-left" class='button_wss'>返回</div>
      </div> -->
    </div>
  </div>
</template>
<script>



export default {
  components: {  },
  data() {

    return {
      drawer_data:false,
      unfold_name:'',//当前展开作业的名称
      drawer_homework_exam:false,
      li_active:2,
      count:0,
      cur_page:1,
      page_size:20,
      data_form_active:0,
      list_usual:[],
      list_unfold:[],
      list_unfold_data:[],
      topic_level:[],
      topic_level_avtive:-1,
      type_json:[],
      type_json_active:-1,
      userInfo:'',
    };
  },
  mounted() {
   
    // document.addEventListener('scroll', this.load, true);//监听滚动条
    let courseInfo=localStorage.getItem('tocanvas_courseInfo') ||{}
    // let courseInfo={"id":2937,"subject_code":"a0","chapter_code":"a40b16","teacher_uuid":"6ce8aca2-adb3-ddb8-fa6e-48967c40e81c","createtime":1621822415,"school_code":"a001","course_src_uuid":"e135849d-e799-3d37-d3e6-978bcce8e73c","course_name":"88888888","class_id":925,"class_usages_json":"","endtime":1621995092,"course_class_status":1,"live_setting":"","starttime":0,"class_content":"{\"i\":\"重点\",\"d\":\"难点\",\"e\":\"考点\",\"b\":{\"uuid\":[{\"id\":1736,\"title\":\"666666666666\",\"createtime\":\"2020-09-11 14:24:32\",\"homework_uuid\":\"3a04051c-bcb9-6f1b-6680-dc1f273ddcc9\"}],\"f\":[{\"id\":3883,\"material_uuid\":\"df532b9b-3bad-106c-eceb-7fc368ad1a99\",\"owner_uuid\":\"6ce8aca2-adb3-ddb8-fa6e-48967c40e81c\",\"from\":\"椒江二中\",\"createtime\":\"2020-08-20 11:09:34\",\"chapter_code\":\"a40b166effc70e84\",\"name\":\"政治-181955.rar\",\"file\":\"[{\\\"name\\\":\\\"政治-181955.rar\\\",\\\"url\\\":\\\"/uploads/other/20200820/4f5c82c1418a2b974906dacaf0226862.rar\\\",\\\"type\\\":\\\"rar\\\",\\\"id\\\":2}]\",\"file_src\":\"\",\"file_type\":\"\",\"heat\":0,\"file_ext_txt\":\"\",\"material_label_id\":0,\"sub_num\":1,\"serial\":1}]},\"m\":{\"uuid\":[],\"f\":[]},\"a\":{\"uuid\":[],\"f\":[]}}","course_type":1,"day_starttime":1622044800,"day_index":3,"node_index":1,"union_index":"1622044800_1","course_process":"","content":{"b":{"uuid":[],"exam":[],"f":[{"id":3883,"material_uuid":"df532b9b-3bad-106c-eceb-7fc368ad1a99","owner_uuid":"6ce8aca2-adb3-ddb8-fa6e-48967c40e81c","from":"椒江二中","createtime":"2020-08-20 11:09:34","chapter_code":"a40b166effc70e84","name":"政治-181955.rar","file":"[{\"name\":\"政治-181955.rar\",\"url\":\"/uploads/other/20200820/4f5c82c1418a2b974906dacaf0226862.rar\",\"type\":\"rar\",\"id\":2}]","file_src":"","file_type":"","heat":0,"file_ext_txt":"","material_label_id":0,"sub_num":1,"serial":1}]},"a":{"uuid":[],"exam":[],"f":[]},"m":{"uuid":[],"exam":[],"f":[]}}}
    this.chapter_code=courseInfo.chapter_code||''
    this.subject_code=courseInfo.subject_code||''
    this.userInfo=JSON.parse(sessionStorage.userInfo)
     this.get_Topic_type() //习题类型 用来筛选习题已经习题分类
   
    // this.get_my_Guidance()
    this.get_my_HomeWork()
  },
  methods: {
    load_el(){
      // console.log(111)
    },
    addto_canvas(data){
      // console.log(data)
      if(this.li_active==5||this.li_active==6||this.li_active==7||this.li_active==8){
        // console.log(JSON.parse(data.file)[0])
        window.parent.loadIframeFlie(JSON.parse(data.file)[0])
      }else{

        window.parent.loadIframeFlie(data)
      }

    },
    //展开作业 考卷
    preview_homework_exam(item){
      this.drawer_homework_exam=true
      let content
      try {
        content=JSON.parse(item.content)
      } catch (error) {
        content=[] 
      }
      this.list_unfold=content
      this.list_unfold_add_all=item
      this.unfold_name=item.title||item.name
    },
    // 切换导学案 作业 资料 考卷 题库
    choose_type(type){
      if(this.li_active==type){
        return
      }
      if(this.li_active!=type){
        this.list_usual=[]
        this.list_unfold=[]
      }
      this.cur_page=1
      this.li_active=type
      if(this.li_active==0){
        if(this.data_form_active==0){
          this.get_my_Guidance()
        }else if(this.data_form_active==1){
          this.get_share_Guidance()
        }else if(this.data_form_active==2){
          this.get_school_Guidance()
        }else if(this.data_form_active==3){
          this.get_cloud_Guidance()
        }
      }else if(this.li_active==1||this.li_active==5||this.li_active==6||this.li_active==7||this.li_active==8){
        if(this.data_form_active==0){
          this.get_my_Data()
        }else if(this.data_form_active==1){
          this.get_share_Data()
        }else if(this.data_form_active==2){
          this.get_school_Data()
        }else if(this.data_form_active==3){
          this.get_cloud_Data()
        }
      }else if(this.li_active==2){
        if(this.data_form_active==0){
          this.get_my_HomeWork()
        }else if(this.data_form_active==1){
          this.get_share_HomeWork()
        }else if(this.data_form_active==2){
          this.get_school_HomeWork()
        }else if(this.data_form_active==3){
          this.get_cloud_HomeWork()
        }
      }else if(this.li_active==3){
        if(this.data_form_active==0){
          this.get_my_exam()
        }else if(this.data_form_active==1){
          this.get_share_exam()
        }else if(this.data_form_active==2){
          this.get_school_exam()
        }else if(this.data_form_active==3){
          this.get_cloud_exam()
        }
      }else if(this.li_active==4){
        if(this.data_form_active==0){
          this.get_my_Topic()
        }else if(this.data_form_active==1){
          this.get_share_Topic()
        }else if(this.data_form_active==2){
          this.get_school_Topic()
        }else if(this.data_form_active==3){
          this.get_cloud_Topic()
        }
      }
    },
    //选择  我的、学习、共享、云
    data_form(type){
    
      // console.log(this.li_active)
      if(this.data_form_active==type){
        return
      }
      if(this.data_form_active!=type){
        this.list_usual=[]
        this.list_unfold=[]
      }
      this.cur_page=1
      this.data_form_active=type
       if(this.li_active==0){
        if(this.data_form_active==0){
          this.get_my_Guidance()
        }else if(this.li_active==1||this.li_active==5||this.li_active==6||this.li_active==7||this.li_active==8){
          this.get_share_Guidance()
        }else if(this.data_form_active==2){
          this.get_school_Guidance()
        }else if(this.data_form_active==3){
          this.get_cloud_Guidance()
        }
      }else if(this.li_active==1||this.li_active==5||this.li_active==6||this.li_active==7||this.li_active==8){
        if(this.data_form_active==0){
          this.get_my_Data()
        }else if(this.data_form_active==1){
          this.get_share_Data()
        }else if(this.data_form_active==2){
          this.get_school_Data()
        }else if(this.data_form_active==3){
          this.get_cloud_Data()
        }
      }else if(this.li_active==2){
        if(this.data_form_active==0){
          this.get_my_HomeWork()
        }else if(this.data_form_active==1){
          this.get_share_HomeWork()
        }else if(this.data_form_active==2){
          this.get_school_HomeWork()
        }else if(this.data_form_active==3){
          this.get_cloud_HomeWork()
        }
      }else if(this.li_active==3){
        if(this.data_form_active==0){
          this.get_my_exam()
        }else if(this.data_form_active==1){
          this.get_share_exam()
        }else if(this.data_form_active==2){
          this.get_school_exam()
        }else if(this.data_form_active==3){
          this.get_cloud_exam()
        }
      }else if(this.li_active==4){
        if(this.data_form_active==0){
          this.get_my_Topic()
        }else if(this.data_form_active==1){
          this.get_share_Topic()
        }else if(this.data_form_active==2){
          this.get_school_Topic()
        }else if(this.data_form_active==3){
          this.get_cloud_Topic()
        }
      }

    },
    //下拉加载用
    load(){
      let scrollHeight
    //   try {
    //     scrollHeight=this.$refs.listBox.scrollHeight-this.$refs.listBox.clientHeight+this.$refs.listBox.scrollTop
    //   } catch (error) {
        
    //   }
    //  if(scrollHeight>0||Math.ceil(this.count/this.page_size)<=this.cur_page){
    //   return
    //  }
  
      this.cur_page++
      if(this.li_active==0){
        if(this.data_form_active==0){
          this.get_my_Guidance()
        }else if(this.data_form_active==1){
          this.get_share_Guidance()
        }else if(this.data_form_active==2){
          this.get_school_Guidance()
        }else if(this.data_form_active==3){
          this.get_cloud_Guidance()
        }
      }else if(this.li_active==1||this.li_active==5||this.li_active==6||this.li_active==7||this.li_active==8){
        if(this.data_form_active==0){
          this.get_my_Data()
        }else if(this.data_form_active==1){
          this.get_share_Data()
        }else if(this.data_form_active==2){
          this.get_school_Data()
        }else if(this.data_form_active==3){
          this.get_cloud_Data()
        }
      }else if(this.li_active==2){
        if(this.data_form_active==0){
          this.get_my_HomeWork()
        }else if(this.data_form_active==1){
          this.get_share_HomeWork()
        }else if(this.data_form_active==2){
          this.get_school_HomeWork()
        }else if(this.data_form_active==3){
          this.get_cloud_HomeWork()
        }
      }else if(this.li_active==3){
        if(this.data_form_active==0){
          this.get_my_exam()
        }else if(this.data_form_active==1){
          this.get_share_exam()
        }else if(this.data_form_active==2){
          this.get_school_exam()
        }else if(this.data_form_active==3){
          this.get_cloud_exam()
        }
      }else if(this.li_active==4){
        if(this.data_form_active==0){
          this.get_my_Topic()
        }else if(this.data_form_active==1){
          this.get_share_Topic()
        }else if(this.data_form_active==2){
          this.get_school_Topic()
        }else if(this.data_form_active==3){
          this.get_cloud_Topic()
        }
      }

    },
    //获取我的导学案
    get_Guidance(url,type){
      let formData = new FormData();
      formData.append("chapter_code", this.chapter_code);
      formData.append("current_page", this.cur_page);
      formData.append("page_size", this.page_size);
      if(type){
        formData.append("status", type);
      }
      this.axios.post(url, formData).then(res => {
        if(res.data.code==1){
           this.count=res.data.data.count
          for(let i in res.data.data.data){
            this.list_usual.push(res.data.data.data[i])
          }
        }else{
          this.$message({
            type:'error',
            message:res.data.msg,
            duration:1500,showClose: true
          })
        }
      })
    },
    get_my_Guidance(){
      this.get_Guidance('/school/Collection_Guidance/collectionList')
    },
    //获取共享导学案
    get_share_Guidance(){
      this.get_Guidance('/school/guidance/guidanceList',2)
    },
    //获取学校导学案
    get_school_Guidance(){
      this.get_Guidance('/school/guidance/guidanceList',3)
    },
    //获取云导学案
    get_cloud_Guidance(){
      this.get_Guidance('/teacher/guidance/getlist')
    },
    //获取我的资料
    get_Data(url,type){
      let formData = new FormData();
      formData.append("chapter_code", this.chapter_code);
      formData.append("current_page", this.cur_page);
      formData.append("page_size", this.page_size);
      formData.append("subject_code", this.subject_code);
      if(this.li_active==1){
        formData.append("file_type", 1);
      }else if(this.li_active==5){
        formData.append("file_type", 2);
      }
      else if(this.li_active==6){
        formData.append("file_type", 3);
      }
      else if(this.li_active==7){
        formData.append("file_type", 4);
      }
      else if(this.li_active==8){
        formData.append("file_type", 5);
      }
      
      if(type){
        formData.append("status", type);
      }
      this.axios.post(url, formData).then(res => {
        if(res.data.code==1){
           this.count=res.data.data.total||res.data.data.count
           let arr_data=res.data.data.data||res.data.data.list
          for(let i in arr_data){
            this.list_usual.push(arr_data[i])
            // let arr_temp
            // try {
            //   arr_temp=JSON.parse(arr_data[i].file)
            // } catch (error) {
            //   arr_temp=arr_data[i].file
            // }
            // for(let j in arr_temp){
            //   this.list_usual.push(arr_temp[j])
            // }
          }
          // console.log(this.list_usual)
        }else{
          this.$message({
            type:'error',
            message:res.data.msg,
            duration:1500,showClose: true
          })
        }
      })
    },
    get_my_Data(){
      this.get_Data('/school/Collection_material/collectionList')
    },
    //获取共享资料
    get_share_Data(){
      this.get_Data('/school/Material/materialList',2)
    },
    //获取学校资料
    get_school_Data(){
      this.get_Data('/school/Material/materialList',3)
    },
    //获取云资料
    get_cloud_Data(){
      this.get_Data('/teacher/course/getmateriallist')
    },
    //展开资料
    preview_data(item){
      this.drawer_data=true
      let content
      try {
        content=JSON.parse(item.file)
      } catch (error) {
        content=[] 
      }
      this.list_unfold_data=content
      this.unfold_name=item.title||item.name
    },
     //获取我的作业
    get_HomeWork(url,type){
      let formData = new FormData();
      formData.append("chapter_code", this.chapter_code);
      formData.append("current_page", this.cur_page);
      formData.append("page_size", this.page_size);
      if(type){
        formData.append("status", type);
      }
      this.axios.post(url, formData).then(res => {
        if(res.data.code==1){
           this.count=res.data.data.total||res.data.data.count
           let arr_data=res.data.data.data||res.data.data.list
          for(let i in arr_data){
            this.list_usual.push(arr_data[i])
          }
          
        }else{
          this.$message({
            type:'error',
            message:res.data.msg,
            duration:1500,showClose: true
          })
        }
      })
    },
    get_my_HomeWork(){
      this.get_HomeWork('/school/Collection_homework/collectionList')
    },
    //获取共享作业
    get_share_HomeWork(){
      this.get_HomeWork('/school/Homework/HomeworkList',2)
    },
    //获取学校作业
    get_school_HomeWork(){
      this.get_HomeWork('/school/Homework/HomeworkList',3)
    },
    //获取云作业
    get_cloud_HomeWork(){
      this.get_HomeWork('/teacher/homework/getlist')
    },
     //获取我的考卷
    get_exam(url,type){
      let formData = new FormData();
      formData.append("chapter_code", this.chapter_code);
      formData.append("current_page", this.cur_page);
      formData.append("page_size", this.page_size);
      formData.append("subject_code", this.subject_code);
      if(type){
        formData.append("status", type);
      }
      this.axios.post(url, formData).then(res => {
        if(res.data.code==1){
           this.count=res.data.data.total||res.data.data.count
           let arr_data=res.data.data.data||res.data.data.list
          for(let i in arr_data){
            this.list_usual.push(arr_data[i])
          }
          
        }else{
          this.$message({
            type:'error',
            message:res.data.msg,
            duration:1500,showClose: true
          })
        }
      })
    },
    get_my_exam(){
      this.get_exam('/school/Collection_exampaper/collectionList')
    },
    //获取共享考卷
    get_share_exam(){
      this.get_exam('/school/examPaper/examPaperList',2)
    },
    //获取学校考卷
    get_school_exam(){
      this.get_exam('/school/examPaper/examPaperList',3)
    },
    //获取云考卷
    get_cloud_exam(){
      this.get_exam('/teacher/examPaper/getlist')
    }, //获取我的题库
    get_Topic(url,type){
      try {
        this.subject_code=JSON.parse(localStorage.userInfo).subject_code
      } catch (error) {
        
      }
      let formData = new FormData();
      formData.append("chapter_code", this.chapter_code);
      formData.append("current_page", this.cur_page);
      formData.append("page_size", this.page_size);
      formData.append("subject_code",  this.subject_code);
      if(this.get_topic_level){
        formData.append("level", this.get_topic_level);
      }
      if(this.get_topic_type){
        formData.append("type_id", this.get_topic_type);
      }
      if(type){
        formData.append("status", type);
      }
      this.axios.post(url, formData).then(res => {
        if(res.data.code==1){
           this.count=res.data.data.total||res.data.data.count
           let arr_data=res.data.data.data||res.data.data.list
          for(let i in arr_data){
            this.list_usual.push(arr_data[i])
            
          }
        }else{
          this.$message({
            type:'error',
            message:res.data.msg,
            duration:1500,showClose: true
          })
        }
      })
    },
    get_my_Topic(){
      this.get_Topic('/school/Collection_tiku/collectionList')
    },
    //获取共享题库
    get_share_Topic(){
      this.get_Topic('/school/tiku/tikuList',2)
    },
    //获取学校题库
    get_school_Topic(){
      this.get_Topic('/school/tiku/tikuList',3)
    },
    //获取云题库
    get_cloud_Topic(){
      this.get_Topic('/teacher/tiku/getlist')
    },
    //获取习题分类 难度、类型
    get_Topic_type(){
      let formData = new FormData();
      formData.append("subject_code", this.subject_code);
      this.axios.post('/teacher/subject/getlist', formData).then(res => {
        if(res.data.code==1){
          this.get_Topic_type=res.data.data 
          this.topic_level=res.data.data.difficulty
          try {
            this.type_json=JSON.parse(res.data.data.tiku_type.type_json)
          } catch (error) {
            
          }
          // console.log(this.type_json)
        }else{
          this.$message({
            type:'error',
            message:res.data.msg,
            duration:1500,showClose: true
          })
        }
      })
    },
    //返回习题类型
    returnTopic_type(id){
      let type_json
      try {
        type_json=JSON.parse( this.get_Topic_type.tiku_type.type_json )
      } catch (error) {
        type_json=[]
      }
      for(let i in type_json){
        if(type_json[i].id==id){
           return type_json[i].n
        }
      }
    },
    //选择习题难度
    choose_topic_level(id,i){
      this.get_topic_level=id
      this.topic_level_avtive=i
      this.list_usual=[]
      this.list_unfold=[]
      if(this.data_form_active==0){
        this.get_my_Topic()
      }else if(this.data_form_active==1){
        this.get_share_Topic()
      }else if(this.data_form_active==2){
        this.get_school_Topic()
      }else if(this.data_form_active==3){
        this.get_cloud_Topic()
      }
    },
    //选择习题类型
    choose_topic_type(id,i){
      this.get_topic_type=id
      this.type_json_active=i
      this.list_usual=[]
      this.list_unfold=[]
      this.cur_page=1
      if(this.data_form_active==0){
        this.get_my_Topic()
      }else if(this.data_form_active==1){
        this.get_share_Topic()
      }else if(this.data_form_active==2){
        this.get_school_Topic()
      }else if(this.data_form_active==3){
        this.get_cloud_Topic()
      }
    },
    //关闭资源库
    close_dataBank(){
      window.parent.loadCloseIframe()
    }

  },

 
  beforeDestroy() {
   
  }
};
</script>


<style scoped>
 .left_box{
     width: 85vw;
    display: flex;
    flex-direction: column;
    background: #f2f2f2;
   /* border-right: 1px solid #CCCCCC; */
 }
 .content_1{
   flex: 1;
   overflow-y: scroll;
   flex-direction:column-reverse;
   display:flex;
   padding: 2vw;

 }
 .content{
   flex: 1;
   overflow-y: scroll;
   flex-wrap: wrap;
   flex-direction:row-reverse;
   /* flex-direction:column-reverse; */
   display:flex;
   padding: 2vw;
 }
 .dataItem{
     display: flex;
    justify-content: space-between;
    background: white;
    margin: 1vw 2vw;
    margin-top: 0;
    padding: 5vw 3.6vw 5vw 3.4vw;
    line-height: 8.14vw;
    box-sizing: content-box
    /* width: calc(50% - 2vw);
    height: 28vw; */
    /* box-shadow: 0px 0px 4px 0px #CCCCCC;
    border-radius: 2px;
    margin: 3vw 0;
    position: relative;
    background: linear-gradient(0deg,#8a8a8a 0% ,white 70%);  */
    
 }
 .content_2{
   flex: 1;
   display: flex;
   padding: 2vw 4vw;
   overflow-y: scroll;
   flex-wrap: wrap;
   /* flex-direction: column-reverse; */
   justify-content: space-between;
   align-content: flex-start;
 }
 .dataItem_2{
     box-sizing: content-box;
    width: calc(50% - 2vw);
    height: 23vw;
    box-shadow: 0px 0px 4px 0px #CCCCCC;
    border-radius: 2px;
    margin: 3vw 0;
    position: relative;
    /* background: linear-gradient(0deg,#8a8a8a 0% ,white 75%);  */
    position: relative;
    

 }
 .dataItem_name{
    position: absolute;
    bottom: 0vw;
    font-size: 3vw;
    height: 55%;
    /* line-height: 80%; */
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #F7F7F7;
    width: 80%;
    border-radius: 2px;
    display: flex;
    align-items: center;
    /* left: 10%; */
    /* text-align: center; */
    padding: 0 10%;
    padding-top: 45%;
    background: linear-gradient(
            0deg, rgba(138,138,138,0.8) 0% ,rgba(255,255,255,0.0) 45%);;
 }
 .dataItem_name>div:nth-of-type(1) img{
   display: block;
 }
 .dataItem_name>div:nth-of-type(2){
   width: 80%;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   margin-left: 6%;
 }
 .dataItem_contnet img{
   width: 30%;
   margin: 3vw auto;
   display: block;
 }
 .dataItem>div:nth-of-type(1){
   width: 8.14vw;
   height: 8.14vw;
   margin-right:4.75vw;
   font-size: 8.14vw !important;
 }
 .dataItem>div:nth-of-type(2){
   flex: 1;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
   margin-right: 2.26vw;
 }
 .dataItem>div:nth-of-type(3){
 
 }
 
 .right_box{
   width: 15vw;
   position: relative;
   color: #13BFA3;
   box-shadow: 0px 0px 4px 0px #CCCCCC;
 }
 .right_box ul{
   position: fixed;
   bottom: 18vw;
 }
 .right_box li {
    text-align: center;
    cursor: pointer;
    padding: 2.71vw 0;
 }
 .right_box li:hover{
    background: #13bfa3 !important;
    color: white;
 }
 .li_active{
    background: #13bfa3 !important;
     color: white;
 }
 .item_icon{
    width: 11vw;
    height:11vw;
    border-radius: 50%;
    margin: 0 2vw;
    background: #13BFA3;
    color: white;
    text-align: center;
    line-height: 11vw;
    margin-bottom: 1.13vw;
    font-size: 5.14vw !important;
 }  
 .head_box{
  height: calc(100vh - 14.48vw);
   
 }
 .foot_box{
   height: 14.48vw;
   box-shadow: 0px 0px 4px 0px #CCCCCC;
   overflow: hidden;
   display: flex;
   justify-content: space-between;
 }
 .foot_back{
   width: 15vw;
   text-align: center;
   box-shadow: #CCCCCC -4px 0 4px -4px;
   color: #13BFA3;
   height: 10.4vw;
   margin:2vw 0 ;
   cursor: pointer;
 }
 .data_form{
   display: flex;
   background: #E0F1EE;
   border-radius: 4vw;
   margin: 3.17vw 6.79vw;
   height: 9vw;
   line-height: 9vw;
   text-align: center;
   flex: 1;
 }
 .data_form >div{
   flex: 1;
   border-radius: 4vw;
   cursor: pointer;
   color: #13BFA3;
 }
 .data_form_active{
   background: #13BFA3 !important;
   color: white  !important;
 }
 .data_form >div:hover{
   background: #13BFA3 !important;
   color: white  !important;
 }
 .unfold_wrapper{
   width: 100%;
   height: 100vh;
   background: #f2f2f2;
   display: flex;
   flex-direction: column;
   
 }
 .unfold_content{
   flex: 1;
   overflow-y:scroll;
   display: flex;
   flex-direction:column-reverse
 }
 .unfold_foot{
   display: flex;
   justify-content: space-between;
   height: 6.33vw;
   padding: 2.26vw 3.62vw 2.26vw 5.2vw;
   box-shadow: #CCCCCC 4px 0 4px 4px;
   line-height:6.33vw;
 }
 .unfold_content{
   background: white;
   margin: 1.5vw;
 }
 .unfold_content_title{
   height: 10.86vw;
   line-height: 10.86vw;
   padding:0 3.85vw;
   font-size: 4.52vw;
   background: #13BFA3;
   border-radius: 8px 8px 0px 0px;
   color: white;
 }
 .unfold_content_content{
   margin:3.26vw 2.71vw;
   /* margin-bottom: 2.71vw; */
   background: #f2f2f2;
   padding: 3.26vw;
   overflow: hidden;
   /* height: 20vw; */
   cursor: pointer;
 }
 .choose_status{
   display: flex;
   overflow-x: scroll;
   margin: 0 3.17vw;
 }
 .choose_status >div{
    padding: 0 4.13vw;
    flex: 1;
    white-space: nowrap;
    height: 7.24vw;
    border-radius: 6px;
    margin-right: 2.94vw;
    line-height: 7.24vw;
    text-align: center;
    cursor: pointer;
 }
 .status_active{
   background: #13BFA3;
   color: white;
 }
  .wrapper{
   font-size:0.8vw
 }
 .button_wss{
   height: 3.33vw;
   line-height: 3.33vw;
   color: white;
   text-align: center;
   border-radius: 1.13vw;
    font-size: 4vw;
    padding: 2.3vw;
    width: 10vw;
    cursor: pointer;
 }
 .iconfont{
   font-size: 3.8vw ;
 }

 
 /* 2.0 */
</style>
  